export const PAYMENT_NOTE_KEY = "payment_note";
export const OVERRIDE_KEY = "override";  // If an invoice already exists, generate a new one anyway
export const EMAIL_KEY = "email";
export const MEALS_KEY = "meals";
export const FULL_NAME_KEY = "full_name";
export const INVOICE_QUERY_PARAM_FORMAT = "format";